<template>
  <div class="admin-sidebar" @click="$emit('click')">
    <component :is="itemComponent" name="item" :to="'/admin/dashboard'">{{
      capitalize($t("titles.dashboard"))
    }}</component>

    <template v-if="isGlobalAdmin || hasMoreThanOneAdminCommunity">
      <component :is="itemComponent" name="item" to="/admin/communities">{{
        $tc("communities.model_name", 2) | capitalize
      }}</component>
      <component :is="itemComponent" name="item" to="/communities">{{
        $t("titles.map") | capitalize
      }}</component>
      <component :is="itemComponent" name="item" to="/admin/users">{{
        $tc("users.model_name", 2) | capitalize
      }}</component>
    </template>
    <template v-else-if="firstAdminCommunity">
      <component
        :is="itemComponent"
        name="item"
        :to="`/admin/communities/${firstAdminCommunity.id}`"
        >{{ firstAdminCommunity.name }}</component
      >
      <component :is="itemComponent" name="item" to="/communities">{{
        $t("titles.map") | capitalize
      }}</component>
    </template>
    <component :is="itemComponent" name="item" to="/admin/invitations">{{
      $t("titles.invitations") | capitalize
    }}</component>
    <component :is="itemComponent" name="item" to="/admin/loanables">{{
      $tc("loanables.model_name", 2) | capitalize
    }}</component>
    <component :is="itemComponent" v-if="isGlobalAdmin" name="item" to="/admin/libraries">{{
      $tc("libraries.library", 2) | capitalize
    }}</component>
    <component :is="itemComponent" name="item" to="/admin/loans">{{
      $tc("loans.model_name", 2) | capitalize
    }}</component>
    <component :is="itemComponent" v-if="isGlobalAdmin" name="item" to="/admin/pricings">{{
      $tc("pricings.pricing", 2) | capitalize
    }}</component>
    <component :is="itemComponent" v-if="isGlobalAdmin" name="item" to="/admin/invoices">{{
      $tc("invoices.invoice", 2) | capitalize
    }}</component>
    <component :is="itemComponent" v-if="isGlobalAdmin" name="item" to="/admin/payouts">{{
      $t("titles.payouts") | capitalize
    }}</component>
    <component
      :is="sectionComponent"
      v-if="isGlobalAdmin"
      :class="sectionClass"
      name="section"
      @click.prevent.stop="() => (advancedVisible = !advancedVisible)"
    >
      <div class="admin-sidebar-section-title">
        <b-icon
          font-scale="0.75"
          icon="chevron-right"
          class="sidebar-section-icon"
          :class="{
            'sidebar-section-icon-open': advancedVisible,
          }"
        />
        {{ $t("titles.advanced") | capitalize }}
      </div>
    </component>
    <b-collapse
      v-if="isGlobalAdmin"
      id="admin_sidebar_advanced"
      class="admin-sidebar-section"
      :visible="advancedVisible"
      tag="ul"
    >
      <component :is="itemComponent" name="item" to="/admin/mailinglists">{{
        $t("titles.mailinglists") | capitalize
      }}</component>
      <component :is="itemComponent" name="item" to="/admin/gbfs_datasets">{{
        $t("titles.gbfs") | capitalize
      }}</component>
      <component :is="itemComponent" name="item" to="/admin/reports">{{
        $t("titles.reports") | capitalize
      }}</component>
    </b-collapse>
  </div>
</template>

<script>
import { capitalize } from "@/helpers/filters";
import { getAdminCommunities } from "@/helpers/permissions/communities";
import { isGlobalAdmin } from "@/helpers/permissions/users";

export default {
  name: "AdminSidebar",
  props: {
    sectionClass: {
      type: String,
      default: "",
    },
    itemComponent: {
      type: String,
      default: undefined,
    },
    sectionComponent: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      advancedVisible: false,
    };
  },
  computed: {
    isGlobalAdmin() {
      return isGlobalAdmin(this.$store.state.user);
    },
    hasMoreThanOneAdminCommunity() {
      return (getAdminCommunities(this.$store.state.user) || []).length > 1;
    },
    firstAdminCommunity() {
      return (getAdminCommunities(this.$store.state.user) || []).find(() => true);
    },
  },
  methods: { capitalize },
};
</script>

<style lang="scss">
.admin-sidebar {
  .admin-sidebar-section-title {
    display: flex;
    align-items: center;
  }
  .sidebar-section-icon {
    transition-duration: 0.3s;
    margin-right: 0.5rem;

    &.sidebar-section-icon-open {
      transform: rotate(90deg);
    }
  }

  .nav-item a.nav-link {
    color: $black;

    &.disabled {
      color: $grey;
    }

    &.router-link-active,
    &:hover {
      color: $locomotion-green;
    }
  }

  .admin-sidebar-section {
    list-style: none;
    padding-left: 1.25rem;
  }
}
</style>
